<template>
       <!-- Start Main Content -->
       <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-2 py-2 sm:p-1 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Consumption (खतावणी)</h6>
                </div>
                <label>Date : <input type="date" v-model="sale.date"></label>
            </div>
           
            <div class="overflow-x-auto scrollbar-table px-1.5 py-4">
                
                   <div class="mt-2 grid sm:grid-cols-1  md:grid-cols-2 lg:grid-cols-2 gap-6">
                        <div>
                            <label for="tagname" class="form-label">Branch Name 
                                <a class="text-danger border px-4" @click="addbranchModal()" ><i class="ri-add-line text-danger text-[13px]"></i> Add New Branch</a>
                            </label>
                           <select  class="form-input" id="branch_name" ref="branch_name" v-model="sale.branchid" autofocus>
                                <option  v-for="(item ,index)  in branchList" :value="item.id" >{{item.name}}</option>
                            </select>
                        </div>

                          <div>
                            <label for="tagname" class="form-label">Plot Name 
                                <a class="text-danger border px-4" @click="addPlotModal()" ><i class="ri-add-line text-danger text-[13px]"></i> Add New Plot</a>
                            </label>
                          <select  class="form-input" id="plot_name" ref="plot_name" v-model="sale.plotid" autofocus>
                                <option  v-for="(item ,index)  in plotList" :value="item.id" >{{item.name}}</option>
                        </select>
                        </div>
                       
                   </div>
                       <div class="mt-7 grid grid-cols-1 gap-4">
                               <div>
                                    <label for="tagname" class="form-label">Employee Name 
                                       <a class="text-danger border px-4" @click="addModal()" ><i class="ri-add-line text-danger text-[13px]"></i> Add New Employee</a>
                                    </label>
                                    <select  class="form-input" id="cust_name" ref="cust_name" v-model="sale.consumption_emp" autofocus>
                                            <option  v-for="(item ,index)  in employeeList" :value="item.id" >{{item.name+' '+item.contact}}</option>
                                    </select>
                                </div>
                       </div>
                

            </div>

            <!-- Start All Language List Table -->
            <div class="p-3 sm:p-4"> 
                <div class="overflow-x-auto scrollbar-table">
                    <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
                        <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                            <tr class="bg-gray">
                                
                                <th class="px-1.5 py-4 prd_name_col">Name</th>
                                <th class="px-1.5 py-4 prd_val_col">Batch No</th>
                                <th class="px-1.5 py-4 prd_val_col">Mfg. Date</th>
                                <th class="px-1.5 py-4 prd_val_col">Expiry Date</th>
                                <th class="px-1.5 py-4 prd_val_col">Qty</th>
                                <th class="px-1.5 py-4 prd_val_col">Rate</th>
                                <th class="px-1.5 py-4 prd_val_col">Total</th>
                             
                                <th class="px-1.5 py-4 px-4"> <i class="ri-settings-3-line text-inherit text-[13px]"></i></th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                            <tr  class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white " v-if="sale_product_list.length>0" v-for="(item ,index)  in sale_product_list" :value="item.id" >
                                <td class="" @click="tagModal(index)">{{item.name}}  
                                <!--<i class="ri-price-tag-3-line text-success text-[13px]"></i>-->
                                </td>
                                <td class="text-center">{{item.batchno}}</td>
                                <td class="text-center">{{item.manufacturingdate}}</td>
                                <td class="text-center">{{item.expirydate}}</td>
                                
                                <td class="row">
                                        <input type="number"  class="form-input  text-center" v-model="item.qty"   @input="getTotal_added(item)" />{{item.unit}}
                                     
                                </td> 
                                <td class="">
                                    <input type="number"  class="form-input  text-center" v-model="item.rate" />
                                   </td> 

                                
                                   <td class="text-center">{{calculateTotal(item)}}</td>
                                
                                
                                
                                 <td class="px-4">
                                    <div class="flex items-center gap-1"> 
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(index)" >
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>



                            <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white entry_row" > 
                                <td class="">
                                    <select  class="form-input" id="prd_name" v-model="prd.prdid">
                                            <option  v-for="(item ,index)  in productsList" :value="item.id" >{{item.name}}</option>
                                    </select>

                                     </td>
                                <td class="">
                                    <select  class="form-input" id="batch_no"  ref="batch_no" @change="onBatchChange"  v-model="prd.batchno">
                                            <template v-for="(item ,index)  in batchnos"  :key="item.id" >
                                                <option :value="item.batchNo">{{item.batchNo }} ({{item.stock}})</option>
                                            </template> 
                                    </select>
                                </td>
                                <td class="">
                                    
                                    <input type="text" readonly class="form-input text-center" ref="mfdate" id="mfdate" v-model="prd.manufacturingdate" >
                                
                                </td>
                                <td class="">
                                    
                                    <input type="text" readonly class="form-input text-center" ref="expdate" id="expdate" v-model="prd.expirydate" >
                                
                                </td>
                                <td class="row">
                                    
                                        <input type="number" class="form-input text-center" ref="qty" id="qty" v-model="prd.qty" @input="getTotal()" v-on:keyup.enter="addToCart()" >{{prd.unit}}
                                    
                                    </td>
                                      <td class="">
                                    
                                        <input type="number" class="form-input text-center" ref="rate" id="rate" v-model="prd.rate" @input="getTotal()" v-on:keyup.enter="addToCart()" >
                                    
                                    </td>
                                    <td class="">
                                    
                                        <input type="number" class="form-input text-center" ref="total" id="total" v-model="prd.total" @input="getTotal()" v-on:keyup.enter="addToCart()" >
                                    
                                    </td>
                                <td class="">
                                    <div class="flex items-center gap-1">
                                        <button class="btn-icon btn-primary-icon-light size-7"  @click="addToCart()"  >
                                            <i class="ri-add-line text-inherit text-[13px]"></i>
                                        </button>
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(index)" >
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                    
                    
                    
                    
                    
                    <!-- <tr>
                        <td>Note <a class="text-danger border px-4">
                                            </a></td>
                    </tr>
                    <tr>
                        <td class="prd_name_col"> 
                            <input type="text" v-model="sale.remark" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </td>
                    </tr> -->
                </div>
                
          <div class="space-y-4">
    <!-- Row 1 with two columns (Note and Taaki) -->
    <div class="flex flex-col md:flex-row gap-4">
        <div class="flex-1">
            <label for="" class="block text-gray-700">Note</label>
            <input type="text" v-model="sale.remark" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
        <div class="flex-1">
            <label for="" class="block text-gray-700">Taaki</label>
            <input type="text" v-model="sale.taaki" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
    
        <div class="flex-1">
            <label for="" class="block text-gray-700">Gher</label>
            <input type="text" v-model="sale.ghe" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
        <div class="flex-1">
            <label for="" class="block text-gray-700">Res</label>
            <input type="text" v-model="sale.re" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
        <div class="flex-1">
            <label for="" class="block text-gray-700">Pressure</label>
            <input type="number" v-model="sale.pressure" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
        <div class="flex-1">
            <label for="" class="block text-gray-700">Fan</label>
            <input type="number" v-model="sale.fan" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
        <div class="flex-1">
            <label for="" class="block text-gray-700">Ghan</label>
            <input type="text" v-model="sale.ghan" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
        <div class="flex-1">
            <label for="" class="block text-gray-700">Water</label>
            <input type="number" v-model="sale.water" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>
        <div class="flex-1">
            <label for="" class="block text-gray-700">Total Amount</label>
            <input type="text" v-model="sale.amount" class="form-input w-full border-gray-300 rounded-md" placeholder="Type Here..." autocomplete="off" required>
        </div>

    </div>
</div>
            <!-- <div class="overflow-x-auto scrollbar-table px-1.5 py-4">
                <table class="table-auto w-full ">
                    <tbody>
                    <tr>
                        <td>Total Amount</td>
                        <td>Total Payable</td>
                        <td>Quantity</td>
                        <td>GST</td>
                        <td>Discount</td>
                        <td>Advance</td>
                        <td>Remark</td>
                    </tr>
                    <tr>
                        <td class=""><b>{{account.total}}</b></td>
                        <td class=" "><b>{{account.total_payable}}</b></td>
                        <td class=""><b>{{account.qty}}</b></td>
                        <td class=""><b>{{account.gst}}</b></td>
                        <td class="prd_val_col"><input type="text" class="form-input text-center" @input="getFinalTotal()"  v-on:keyup.enter="focusNext('paid')" v-model="account.discount" ></td>
                        <td class="prd_val_col"><input type="text" ref="paid" class="form-input text-center"  v-on:keyup.enter="focusNext('remark')" @input="getFinalTotal()" v-model="account.paid" ></td>
                        <td class="prd_name_col"><input type="text" ref="remark" class="form-input "   v-on:keyup.enter="focusNext('save_btn')" v-model="account.remark" ></td>
                    </tr>
                    </tbody>
                </table>

            </div> -->
            <!-- <div>
                <label>Delivery Date : <input type="date" v-model="sale.delivery"></label>
            </div> -->
            <div>
                <h5 v-if="account.due>0" class="text-danger">Due Amount : {{account.due}}</h5>
            </div>
             <div class="flex   mt-7">
                            <button @click="save_bill"  ref="save_btn"  class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                            <button @click="print_invoice" v-show="saleid" ref="save_btn"  class="btn b-solid btn-danger-solid cursor-pointer shadow-sm">Print</button>
                        </div> 
            </div>

           
            <!-- End All Language List Table -->
        </div>
    </div>
    <!-- End Main Content -->

    <!-- Start Edit Modal -->
    <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="overflow-y: scroll;    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
              
                <div class="card p-4 lg:p-6" >
                      <form>
                    <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Parent Employee *</label>
                            <select v-model="employee.parent_id" class="form-input">
                            <option v-for="(item, index) in employeeList" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                            </select>

                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Name *</label>
                            <input type="text" v-model="employee.name" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Contact *</label>
                            <input type="text" v-model="employee.contact" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Address *</label>
                            <input type="text" v-model="employee.address" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div> 
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Wages/Salary *</label>
                            <input type="text" v-model="employee.salary" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div> 
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Gender *</label>
                            <select   v-model="employee.gender" class="form-input">
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">DOB *</label>
                            <input type="date" v-model="employee.dob" @change="updateAge" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Age *</label>
                            <input type="text" v-model="employee.age" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                    </div>
                    </form>

                        <div class="flex justify-end mt-5">
                            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->

    <!-- Start Edit Modal -->
    <div id="branchModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="overflow-y: scroll;    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
              
                <div class="card p-4 lg:p-6" >
                      <form>
                    <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Parent Employee *</label>
                            <select v-model="employee.parent_id" class="form-input">
                            <option v-for="(item, index) in employeeList" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                            </select>

                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Name *</label>
                            <input type="text" v-model="employee.name" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Contact *</label>
                            <input type="text" v-model="employee.contact" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Address *</label>
                            <input type="text" v-model="employee.address" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div> 
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Wages/Salary *</label>
                            <input type="text" v-model="employee.salary" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div> 
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Gender *</label>
                            <select   v-model="employee.gender" class="form-input">
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">DOB *</label>
                            <input type="date" v-model="employee.dob" @change="updateAge" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="col-span-full  lg:col-span-6 leading-none">
                            <label for="tagname" class="form-label">Age *</label>
                            <input type="text" v-model="employee.age" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                    </div>
                    </form>

                        <div class="flex justify-end mt-5">
                            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Update</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->

        <!-- Start Edit Modal -->
        <div id="editPlotModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
            <div class="p-4 w-full max-w-lg max-h-full">
                <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                    <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                        <i class="ri-close-line text-inherit text-xl leading-none"></i>
                    </button>
                    <div class="p-4 md:p-5">
                       
                        <div class="p-4 md:p-5">
                            <div class="col-span-full  lg:col-span-6 leading-none">
                                <label for="tagname" class="form-label">Branch Name*</label>
                                <select v-model="plot.branchid" class="form-input">
                                <option v-for="(item, index) in branchList" :key="index" :value="item.id">
                                    {{ item.name }}
                                </option>
                        </select>

                    </div>
    
                            <div class="mt-7">
                                <label for="tagname" class="form-label"> Name *</label>
                                <input type="text" v-model="plot.name" class="form-input" id="first_input" placeholder="Name" autocomplete="off" required >
                            </div>
    
    
                            <div class="mt-7">
                                <label for="tagname" class="form-label"> latitude *</label>
                                <input type="number" v-model="plot.latitude" class="form-input" id="first_input" placeholder="latitude" autocomplete="off" required >
                            </div>

                            
                        <div class="mt-7">
                            <label for="tagname" class="form-label"> longitude *</label>
                            <input type="number" v-model="plot.longitude" class="form-input" id="first_input" placeholder="longitude" autocomplete="off" required >
                        </div>


                        <div class="mt-7">
                            <label for="tagname" class="form-label"> Description *</label>
                            <input type="text" v-model="plot.description" class="form-input" id="first_input" placeholder="Description" autocomplete="off" required >
                        </div>

                        <div class="mt-7">
                            <label for="tagname" class="form-label"> Lines *</label>
                            <input type="number" v-model="plot.line" class="form-input" id="first_input" placeholder="lines" autocomplete="off" required >
                        </div>


                            <div class="flex justify-end mt-7">
                                <button @click="save_plot" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                            </div> 
                    </div>
                </div>
            </div>
        </div>
        </div>
        <!-- End Edit Modal -->

    <!-- start plot Modal -->
    <div id="editbranchModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5">
                   
                        <div class="mt-7">
                            <label for="tagname" class="form-label"> Name *</label>
                            <input type="text" v-model="branch.name" class="form-input" id="first_input" placeholder="Name" autocomplete="off" required >
                        </div>

                        <div class="mt-7">
                        <label for="tagname" class="form-label">Status *</label>
                       <select class="form-input" name="status" id="" v-model="branch.status">
                        <option value="">Choose Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                       </select>
                    </div>


                        <!-- <div class="mt-7">
                            <label for="tagname" class="form-label">Category Status *</label>
                            <select   v-model="cat.status" class="form-input">
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                            </select>

                        </div> -->
                        <div class="flex justify-end mt-7">
                            <button @click="save_branch" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
     <!-- end plot Modal -->
    <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="remove_item()" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
    
     <!-- Start Delete Modal -->
    <div id="tagModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5  ">
                     
                    <div class="mt-5">
                        <h5 class="mb-1 text-center">Add Important Note </h5>
                        
                         <div class="col-span-full lg:col-span-4 leading-none">
                            <label for="" class="form-label">Delivery Date</label>
                            <input type="date" id="delv_on" v-model="selectedProduct.delv_on" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>
                         <div class="col-span-full lg:col-span-4 mt-2 leading-none">
                            <label for="" class="form-label">Note</label>
                            <input type="text" id="note" v-model="selectedProduct.note" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>
                         
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
    
    
    <!-- End Delete Modal -->
</template>
<style scoped>
.form-input{
    height: 20px;
    padding: 15px 2px;
    border: 1px solid black;
    color: black;

}
thead tr{
    background: #95d2ff3b;
}
.select2.select2-container .select2-selection{
    height: 25px;
}
.select2-selection__arrow{
    display: none;
}
.prd_name_col{
    width: 350px;  
}
.prd_val_col{
    width: 80px;  
}
.prd_barcode_col{
    width: 150px;  
}
.entry_row{
    background: yellow;
}
.select2-container{
    width: 100% !important;
}
td{
    color: black;
}
.right{
    text-align: right;
}

select{
    padding: 0px 0px !important;
    height: 30px !important;
}

.form-input:focus{
  background: #f4fcff;
}
.row{
    display: flex;
}

</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
  name: 'SaleView',
  components: {
    
  } ,
  mounted(){
    $(this.$refs.productSelect).select2()
      .on('change', (event) => {
        const selectedProductId = $(event.target).val();
        this.prd.prdid = selectedProductId;  // Update prd.prdid
        
        //  this.prd.batchno=
        //this.fetchBatchNos(selectedProductId); // Fetch batch numbers
      });
      if(this.$route.query.q)
            this.getBasicsForEdit(this.$route.query.q);
        else 
            this.getBasics();
   
  },
  data() {
    return {
        isSet:0,
        isAdd:0,
        isEdit:0,
        saleid:0,
        isDelete: 0,
        deleteId:0,
        productsList:[],
        employeeList:[],
        branchList:[],
        plotList:[],
        selectedProduct:[],
        sale_product_list:[],
        plot:{
        name:'',
        latitude:'',
        longitude:'',
        description:''
       },
       branch:{
        name:'',
        status:'',
       },
       plot:{
        name:'',
        latitude:'',
        longitude:'',
        description:'',
        branchid:'',
        line:'',
        
       },
        employee:{parent_id:'',name:'',contact:'',address:'',salary:'',gender:'',dob:null,age:null},
        Customer:{name:'',cell:'',address:'',gst:''},
       
        sale:{branchid:'',plotid:'',custid:'',remark:'',date:this.todayDate(),taaki:'',ghe:'',re:'',pressure:'',fan:'',ghan:'',amount:'',consumption_emp:'',water:0},
        consumption_emp:{consumption_id:'',consumption_empid:''},
        prd:{prdid:'',batchno:'',manufacturingdate:'',expirydate:'',qty:'',rate:0},
        
        account:{total:0,qty:0,gst:0,paid:0,total_payable:0,discount:0,remark:''},
        prd_select_tag:null,
        employees: {empname:'',emprole:'0',isMainAdmin:0},
        tag_prd_id:0,
        cur_remove_row_index:0,
        batchnos:[]
    }

    }, 
  methods:{
    onBatchChange() {
      const selectedBatch = this.batchnos.find(item => item.batchNo === this.prd.batchno);
      
      if (selectedBatch) {
        this.prd.manufacturingdate = selectedBatch.mfgDate.split(' ')[0];
        this.prd.expirydate = selectedBatch.expiryDate.split(' ')[0];
        this.prd.rate = selectedBatch.rate;
        this.$refs.qty.focus();
      }
    },



    setItemStichType(){
        var self=this;
        if(this.prd.stich_type){
            this.prd.salerate=this.prd.stich_rate;
            this.prd.total=this.prd.stich_rate;
        }
            
            
            setTimeout(() => { self.$refs.qty.focus();}, 200)  
    },
    print_invoice(id)
        {
            if(this.saleid>0)
                //window.open('/print?q='+this.saleid, '_blank');
                  window.open('/thermalPrint?q='+this.saleid, '_blank');
         
        },
    todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate();
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },
    closeModal(){
        $("#editPlotModal").addClass('hidden');
        $("#editbranchModal").addClass('hidden');
            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
            $("#tagModal").addClass('hidden');
        
            this.isAdd=0;
            this.isEdit=0;
            this.isDelete=0;
            this.deleteId=0;
    },
    tagModal(index){
            // this.sale_product_list[index].
            //this.tag_prd_id=index;//this.sale_product_list[index].id;
            
            this.selectedProduct=this.sale_product_list[index];
            $("#tagModal").removeClass('hidden');
            
    },
    addModal(){
        this.employee={parent_id:'',name:'',contact:'',address:'',salary:'',gender:'',dob:null,age:null};
        if(!this.isAdd)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');

            $("#first_input").focus();
        this.isAdd=!this.isAdd;
    },
    addPlotModal(){
        this.plot={
        name:'',
        latitude:'',
        longitude:'',
        description:''
       }

        if(!this.isAdd)
            $("#editPlotModal").removeClass('hidden');
        else
            $("#editPlotModal").addClass('hidden');

            $("#first_input").focus();
        this.isAdd=!this.isAdd;
    },


    addbranchModal(){
        this.branch={
        name:'',
        status:'',
       }

        if(!this.isAdd)
            $("#editbranchModal").removeClass('hidden');
        else
            $("#editbranchModal").addClass('hidden');

            $("#first_input").focus();
        this.isAdd=!this.isAdd;
    },




    focusNext(ref) {
            this.$refs[ref].focus();
        },
    nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
        async fetchBatchNos(productId) {
      console.log("Selected Product ID:", productId);

      if (!productId) {
        console.warn("No product selected");
        return;
      }

    },
    editModal(item){
        if(item){
            let copy = JSON.parse(JSON.stringify(item));
            this.cat=copy;
        }
        if(!this.isEdit)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');
        this.isEdit=!this.isEdit;
    },
    
    deleteModal(id){
        this.deleteId=id;
        if(!this.isDelete)
            $("#deleteModal").removeClass('hidden');
        else
            $("#deleteModal").addClass('hidden');
        this.isDelete=!this.isDelete;
    },

    calculateTotal(item) {
        return item.rate * item.qty; // Calculate total based on rate and quantity
    },


    getTotal_added(item){
        try {
                item.total=((item.qty)?parseFloat(item.qty):parseFloat(item.qty))*((item.rate)?parseFloat(item.rate):parseFloat(item.rate));// parseFloat(item.salerate);
                this.getFinalTotal();



        } catch (error) {
            
        }
    },
    getFinalTotal(){
        try {
            var total_amt=0;
            var total_payable=0;
            var total_qty=0;
            
            
            
            this.sale_product_list.forEach(item => {
                total_amt+=parseFloat(item.qty)*parseFloat(item.rate);;
                total_qty+=parseFloat(item.qty);
            });
            
            this.account.total_payable=total_amt;
            this.account.total=total_amt;
            this.account.qty=total_qty;
            
            //as per 5%
            this.account.gst=total_amt*(5/100);
            
            if(this.account.discount)
                this.account.total_payable=this.account.total_payable- parseFloat(this.account.discount);

            if(this.account.paid)
                this.account.due=this.account.total_payable- parseFloat(this.account.paid);

                this.sale.amount=total_amt;

        } catch (error) {
            
        }
    },
    getTotal(){
        try {
            this.prd.total=parseFloat(this.prd.qty)*parseFloat(this.prd.rate);
            this.getFinalTotal();
        } catch (error) {
            
        }
    },
    async getBasicsForEdit(invoiceid) {
           var self=this;
             axios.post('getSalesBasic',{invoiceid:invoiceid}).then(function (response) {


                    self.productsList=response.data.products;
                    self.employeeList=response.data.employees; 
                    self.plotList=response.data.plots; 
                    self.branchList=response.data.onebranches;  
                    self.employees=response.data.userDetails;

                        var invDetails=response.data.invDetails;
                        var order_items=response.data.order_items;
                        var order_itemss=response.data.order_itemss;
                       
                         self.loadEditData(invDetails,order_items,order_itemss);
                         
                        try {
                            document.getElementById("loader").remove();  
                            sel.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 



                         self.initializeControls(self);
                       
                        //  self.printReceipt();
                  
                        });;
      },
      initializeControls(self){
          
          
        
        $("#cust_name").select2({
                                                        width: '100%',
                                                        dropdownAutoWidth: true,
                                                        placeholder: "Search Employee Here...",
                                                        multiple: true, 
                                                        allowClear: true,
                                                        language: {
                                                            noResults: function() {
                                                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                            }
                                                        },
                                                        escapeMarkup: function (markup) {
                                                            return markup;
                                                        }
                                                    }).on('change', function () {
                                                        // Collect all selected values (array of employee IDs)
                                                        var selected_emp_ids = $(this).val();
                                                        // Set the selected employee IDs in your Vue.js data (or directly in form data)
                                                        self.sale.consumption_emp = selected_emp_ids;  // Assuming you're using Vue.js or similar
                                                    });
           self.prd_select_tag= $("#prd_name").select2({
                                    width: '100%',
                                    dropdownAutoWidth : true,
                                    placeholder:"Search Product Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a ref='add_product' class='  btn-primary-icon-light size-7'>Add Product</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                  }).on('change', function (event) {
                                        self.selectedProduct = self.productsList.find(item => item.id === event.target.value);
                                        self.prd={...self.selectedProduct};
                                        self.prd.prdid=self.selectedProduct.id;
                                        self.batchnos=self.prd.batchlist;
                             
                                        
                                        // self.prd.manufacturingdate = self.batchnos[0].mfgDate.split(' ')[0]; 
                                        // self.prd.expirydate = self.batchnos[0].expiryDate.split(' ')[0];     
                                      
                                        self.getTotal();
                                         setTimeout(() => { self.$refs.batch_no.focus();}, 200)
                                        // self.$refs.qty.focus();
                                    });  
                        
                      
        $("#branch_name").select2({
                                        width: '100%',
                                        dropdownAutoWidth: true,
                                        placeholder: "Search Branch Here...",
                                        language: {
                                            "noResults": function () {
                                                return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                            }
                                        },
                                        escapeMarkup: function (markup) {
                                            return markup;
                                        }
                                    }).on('change', function (event) {

                                        var branchid = $(this).val();
                                        var filteredPlots = self.plotList.filter(item => item.branchid == branchid);
                                        self.sale.branchid=branchid;
                                        $("#plot_name").empty();

                                        filteredPlots.forEach(plot => {
                                            var newOption = new Option(plot.name, plot.id, false, false);
                                            $("#plot_name").append(newOption).trigger('change');
                                        });
                                        $("#plot_name").trigger('change');
                                    });


                                        $("#plot_name").select2({
                                        width: '100%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Plot Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        var selected_plot = self.plotList.find(item => item.id === event.target.value);
                                            if(selected_plot)
                                            {
                                                self.sale.plotid=selected_plot.id;
                                            }
                                             
                                            // self.prd_select_tag.select2('open');
                                        });   
      },
      loadEditData(invDetails,order_items,order_itemss){
        var self=this;
        //  sale:{branchid:'',plotid:'',custid:'',remark:'',date:this.todayDate(),taaki:'',ghe:'',re:'',pressure:'',fan:'',ghan:'',amount:''},
        //consumption_emp:{consumption_id:'',consumption_empid:''},

        self.sale.id=invDetails.id;
        self.sale.branchid=invDetails.branchid;
        self.sale.plotid=invDetails.plotid;
        self.sale.custid=invDetails.custid;
        self.sale.remark=invDetails.remark;
        self.sale.date=invDetails.entry_date;
        self.sale.taaki=invDetails.taaki;
        self.sale.ghe=invDetails.ghe;
        self.sale.re=invDetails.re;
        self.sale.pressure=invDetails.pressure;
        self.sale.fan=invDetails.fan;
        self.sale.ghan=invDetails.ghan;
        self.sale.amount=invDetails.total;
        self.sale.date=invDetails.entry_date; 
         
        for(var i=0;i<order_items.length;i++){
             self.sale_product_list.push({id:order_items[i].prdid,name:order_items[i].prd_name,prdid:order_items[i].prdid,qty:order_items[i].qty,batchno:order_items[i].batchNo,manufacturingdate:order_items[i].mfgDate,expirydate:order_items[i].expiryDate,rate:order_items[i].rate});
        }
        
        let selectedEmps = [];
        for(var i=0;i<order_itemss.length;i++){
             selectedEmps.push(order_itemss[i].consumption_empid);
        }
        self.initializeControls(self);
        self.sale.consumption_emp=selectedEmps.join(",");
        
          this.$nextTick(() => {
                $("#cust_name").val(selectedEmps).trigger("change");
          });
       // , stock: self.sale_product_list,consumption_emp:self.consumption_emp
      },
      async getBasics() {
          var self=this;
            axios.post('getSalesBasic').then(function (response) {
                    self.productsList=response.data.products;
                    self.employeeList=response.data.employees; 
                    self.plotList=response.data.plots; 
                    self.branchList=response.data.onebranches;  
                    self.employees=response.data.userDetails;
               
                    console.log(self.batchnos);
                   }).then(()=>{
                    
                             self.initializeControls(self);
                        });
     },
     alerty(){
        alert('Hello');
     },
     save_category() {
                var self = this; 
                axios.post('saveplot', this.plot)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.plotList=response.data.plot;
                        self.employees=response.data.userDetails;
                        self.cat={name:'',status:'Active'};

                        //self.$swal(msg);
                        if (isSuccess == 1) {
                            self.closeModal();
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },



            save_branch() {
                var self = this; 
                axios.post('addBranch', this.branch)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.plotList=response.data.plot;
                        self.employees=response.data.userDetails;
                        self.cat={name:'',status:'Active'};
                        self.getBasics();

                        //self.$swal(msg);
                        if (isSuccess == 1) {
                            self.closeModal();
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },

            save_plot() {
                var self = this; 
                axios.post('saveplot', this.plot)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.plotList=response.data.plot;
                        self.employees=response.data.userDetails;
                        self.cat={name:'',status:'Active'};

                        //self.$swal(msg);
                        if (isSuccess == 1) {
                            self.closeModal();
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },






     save() {
                var self = this; 
                var selected_cust=0;
                if(self.employee.name==''){
                    self.$swal("Customer Name is Required");
                }else{
                    axios.post('addEmployee', this.employee)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.employeeList=response.data.list;                            
                            
                            selected_cust=response.data.custid;// for default select
                            self.employee={parent_id:'',name:'',contact:'',address:'',salary:'',gender:'',dob:null,age:null};

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        }).then(()=>{
                                 
                                    $("#cust_name").select2({
                                        width: '100%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Customer Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        var selected_customer = self.employeeList.find(item => item.id === event.target.value);
                                            self.sale.custid=selected_customer.id;
                                            self.sale.custcell=selected_customer.contact;
                                            self.sale.custgst=selected_customer.gst;
                                            self.sale.custaddress=selected_customer.address;
                                            self.prd_select_tag.select2('open');
                                        }); 
                                        
                                        $('#cust_name').val(selected_cust);
                                        $('#cust_name').trigger('change');
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },
            save_bill() {
    var self = this;

    if (self.sale.branchid === '') {
        self.$swal("Please Select Branch...");
    }else if (self.sale.plotid === '') {
        self.$swal("Please Select Plot...");
     } else {
        // Sending the sale object and the entire sale_product_list
        axios.post('addSales', { sale: self.sale, stock: self.sale_product_list,consumption_emp:self.consumption_emp })
            .then(response => {
                console.log(response.data);  // Log response from server
                var msg = response.data.msg;
                var isSuccess = response.data.status;
                 
               //
                if (isSuccess == 1) {
                    self.$swal({
                            title: "Success!",
                            text: msg, // The message to display
                            icon: "success", // Success icon
                            buttons: {
                                confirm: {
                                    text: "OK",
                                    value: true,
                                    visible: true,
                                    className: "btn btn-primary",
                                    closeModal: true
                                }
                            }
                        }).then((result) => {
                            if (result) { // If OK button is clicked
                                if (isSuccess == 1) {
                                    self.closeModal();
                window.location.replace(window.location.origin+"/salelist");
                                   // window.location.href = 'http://157.173.221.162:8082/salelist';
                                    
                                    // Uncomment the line below if you want to print the invoice
                                    // self.print_invoice();
                                }
                            }
                        });

                   
                    // self.print_invoice();
                }else
                 self.$swal(msg);
                 
                self.saleid = response.data.sales_id;
                self.productsList = response.data.list;
                self.employeeList = response.data.employees;
                self.Customer = { name: '', cell: '', address: '', gst: '' };

                
            })
            .catch(error => {
                console.log('Error on Authentication: ' + error);
            });
    }
}
,
             
            getBarcode(){
                var self=this;
                if(this.prd.barcode){

                    var found_product = self.sale_product_list.find(item => item.barcode === self.prd.barcode);
                    if(found_product){
                        found_product.qty=found_product.qty+1;
                    }else{
                        self.selectedProduct = self.productsList.find(item => item.barcode === self.prd.barcode);
                        if(self.selectedProduct){
                            self.prd=self.selectedProduct;
                            self.prd.prdname=self.selectedProduct.name;
                            self.prd.qty=1;
                            self.sale_product_list.push({...self.prd});
                        }
                    }

                   
                     
                    self.getFinalTotal();
                    self.prd=[];
                  
                    setTimeout(() => { self.$refs.barcode.focus() }, 300);

                    
                    
                }
            },
            remove_item(){
                
                 this.sale_product_list.splice(this.deleteId, 1);
                // alert(this.deleteId);
                 this.closeModal();
                 
            },
            addToCart(){
                // alert('Y');
                if(this.prd.qty>0){
                    
                    this.sale_product_list.push({...this.prd});
                    this.prd={};
                    
                    this.prd_select_tag.select2('open');
                    this.getFinalTotal();
                }

            }
  }
}
</script>
